import {
  INVITEE_PAGE_REQUEST,
  INVITEE_PAGE_SUCCESS,
  INVITEE_PAGE_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  data: {},
  loading: false,
  error: null,
};
export const invitationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case INVITEE_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case INVITEE_PAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case INVITEE_PAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
